/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiMonitor.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-monitor";

export class AutogenModelEdiMonitor<RowType extends ModelRow> extends Endpoint<RowType, RowEdiMonitorFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiMonitor extends ModelRow<RowEdiMonitorFields> {
	constructor(values?: Partial<RowEdiMonitorFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiMonitorFields {
	company_id: string;
	last_alive: Date;
	last_alive_jms: Date;
	last_poll: number;
	process: string;
	test_interval: number;
}

